module.exports = __webpack_public_path__ + "static/media/reminder.5470f115.svg";